import { useEffect, useState } from 'react';
import { telegram } from '../lib/telegram';
import type { TelegramUser } from '../../../shared/types';

/**
 * Hook to interact with Telegram WebApp
 */
export function useTelegram() {
  const [user, setUser] = useState<TelegramUser | null>(null);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    telegram.init();
    
    const tgUser = telegram.getUser();
    if (tgUser) {
      setUser(tgUser);
    }

    setIsDarkMode(telegram.isDarkMode());
    setIsReady(true);
  }, []);

  return {
    user,
    isDarkMode,
    isReady,
    telegram,
    haptic: telegram.haptic.bind(telegram),
    notificationHaptic: telegram.notificationHaptic.bind(telegram),
    showPopup: telegram.showPopup.bind(telegram),
    showConfirm: telegram.showConfirm.bind(telegram),
    close: telegram.close.bind(telegram),
  };
}


